<div class="flex-parent">
  <div class="login-form-div">
    <div class="header">
      <h2 class="text-details">
        {{'loginForm.codeMessage' | translate}}
      </h2>
    </div>
    <form class="login-form" [formGroup]="codeForm">
      <bos-reactive-mat-form-input [initFocus]="true" [translateKeyPrefix]="'loginForm.'" [fieldName]="'code'"
                                   [parentFormGroup]="codeForm"
                                   [inputType]="'code'"></bos-reactive-mat-form-input>


      <div class="additional-options">
        <form #logoutSubmitCode class="form-hidden" method='GET' action="{{restService.getLogout()}}" >
        </form>
        <button class="login-link forgot-button" mat-flat-button color="accent" matTooltip="{{'loginForm.return' | translate}}"
                (click)="logout()"  type="button">
          <mat-icon class="forgot-icon">reply</mat-icon> {{'loginForm.return' | translate}}
        </button>

      </div>

      <button class="left-margin login-button" mat-flat-button color="primary" [disabled]="!codeForm.valid"
              (click)="code()" type="submit" prevent-double-submit [@inProgress]="inProgress">
        <mat-icon color="accent" class="login-icon">done</mat-icon>

        <app-progress-button  [progress]="inProgress"
                              [success]="success"
                              [standardButtonLabel]="'loginForm.codeButton'"
                              [successButtonLabel]="'loginForm.loginButton.success'">
        </app-progress-button>

      </button>

    </form>
  </div>
</div>



